// extracted by mini-css-extract-plugin
export default {"buttons":"_33034360208f56d1","actionBtn":"b0f131b338dcc6fb"};